import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { useJcFieldId } from '../utils/useJcFieldId';


export interface JcRadioProps extends JcCommonProps {
  readonly label: React.ReactNode;
  readonly selected: boolean;
  readonly onSelect: () => void;
  readonly disabled?: boolean;
  readonly groupName: string;
}


export const JcRadio: React.FunctionComponent<JcRadioProps> = (props: JcRadioProps) => {
  // The id belongs on the input itself, so keep it off the wrapping label.
  const { label, selected, onSelect, disabled, groupName, id, ...otherCommonProps } = props;
  const commonProps = JcUtils.commonProps(otherCommonProps, ["jc-radio", disabled && "jc-disabled"]);
  const inputId = useJcFieldId(id);

  // A <label> wrapper makes the whole control (input + text) clickable and
  // accessible — clicking the text selects the radio natively.
  return <label {...commonProps}>
    <input
      id={inputId}
      type="radio"
      name={groupName}
      checked={selected}
      disabled={disabled}
      onChange={() => onSelect()}
    />
    {label}
  </label>
}
